<div class="board">
  <div class="head">
    <div>
      <h2>Members</h2>
      <p class="sub">
        Who actually uses NX2U. Every account scored on presence, chats, events and
        posts, and tiered from core to dormant. Rebuilt nightly; counts, never content.
      </p>
    </div>
    <div class="head-actions">
      <span class="meta" *ngIf="board?.computedAt as at">
        Snapshot {{ at | date: 'd MMM, HH:mm' }}
      </span>
      <button mat-stroked-button (click)="recompute()" [disabled]="recomputing || loading">
        {{ recomputing ? 'Recomputing…' : 'Recompute now' }}
      </button>
      <button mat-stroked-button (click)="load()" [disabled]="loading">Refresh</button>
    </div>
  </div>

  <div class="notice ok" *ngIf="notice">{{ notice }}</div>
  <div class="notice bad" *ngIf="error">{{ error }}</div>
  <div class="notice warn" *ngIf="board && !board.computedAt">
    No snapshot yet. Press Recompute now to build the first one; after that it
    rebuilds itself every night.
  </div>

  <ng-container *ngIf="board as b">
    <div class="stats">
      <div class="stat">
        <div class="n">{{ b.totals.members }}</div>
        <div class="l">Members<app-info-hint label="Members"
          text="Every account except internal logins and blocked accounts. Those are on the list behind the toggles, but never in these totals."
        ></app-info-hint></div>
      </div>
      <div class="stat">
        <div class="n">{{ b.totals.active30 }}</div>
        <div class="l">Opened the app, 30d</div>
      </div>
      <div class="stat">
        <div class="n">{{ b.totals.regular30 }}</div>
        <div class="l">3+ days, 30d<app-info-hint label="Regulars"
          text="Opened the app on at least three different days in the last 30. The bar for core and returning."
        ></app-info-hint></div>
      </div>
      <div class="stat good">
        <div class="n">{{ tierCount('core') }}</div>
        <div class="l">Core<app-info-hint label="Core"
          text="A regular who also did something social in the last 90 days: sent a chat message, joined an event, posted, or spoke in a lobby."
        ></app-info-hint></div>
      </div>
      <div class="stat">
        <div class="n">{{ tierCount('returning') }}</div>
        <div class="l">Returning<app-info-hint label="Returning"
          text="A regular who only looks: comes back, never chats, joins or posts. The people to ask what is stopping them."
        ></app-info-hint></div>
      </div>
      <div class="stat bad">
        <div class="n">{{ tierCount('lapsed') }}</div>
        <div class="l">Lapsed<app-info-hint label="Lapsed"
          text="Three or more active days between 30 and 90 days ago, and none in the last 30. They saw the app and left; the most valuable feedback there is."
        ></app-info-hint></div>
      </div>
    </div>
  </ng-container>

  <div class="filters">
    <button [class.on]="tier === 'all'" (click)="tier = 'all'">All</button>
    <button *ngFor="let t of tiers" [class.on]="tier === t" (click)="tier = t">
      {{ tierLabel(t) }} <span class="count">{{ tierCount(t) }}</span>
    </button>
    <span class="spacer"></span>
    <input class="search" type="search" placeholder="Name, email, company, city"
      [(ngModel)]="search" />
    <select class="search outreach" [(ngModel)]="outreach" title="How outreach has gone">
      <option value="any">Any outreach</option>
      <option value="not-contacted">Not contacted</option>
      <option value="contacted">Contacted</option>
      <option value="replied">Replied to us</option>
      <option value="no-reply">Contacted, no reply</option>
    </select>
    <label class="toggle"><input type="checkbox" [(ngModel)]="showInternal" />
      internal <span class="count" *ngIf="hiddenInternal">{{ hiddenInternal }}</span></label>
    <label class="toggle"><input type="checkbox" [(ngModel)]="showBanned" />
      blocked <span class="count" *ngIf="hiddenBlocked">{{ hiddenBlocked }}</span></label>
  </div>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>

  <table *ngIf="!loading && rows.length">
    <thead>
      <tr>
        <th>Member</th>
        <th>Tier</th>
        <th class="num sortable" [class.sorted]="sortKey === 'score'" (click)="sortBy('score')">
          Score<app-info-hint label="Score"
            text="Every term is a 90-day window. 3 × active days (30d) + active days (90d) + 2 × chat messages (capped 50) + chats started (capped 20) + 4 × chats that got a reply (capped 20) + 4 × events dated in the window (capped 5) + 3 × posts (90d) + likes (capped 30) + favorites (capped 20) + lobby messages (capped 30). Caps keep one burst account from topping the board."
          ></app-info-hint>
        </th>
        <th class="num sortable" [class.sorted]="sortKey === 'activeDays30'" (click)="sortBy('activeDays30')">
          Days 30 / 90<app-info-hint label="Active days"
            text="Different days on which the app was open, in the last 30 and the last 90. From the minute-level presence pings, so a day counts only if the app was really used."
          ></app-info-hint>
        </th>
        <th class="num sortable" [class.sorted]="sortKey === 'chatMessages90'" (click)="sortBy('chatMessages90')">
          Chats<app-info-hint label="Chats"
            text="Messages sent in the last 90 days, then chats started / chats where someone answered, in the same window. A conversation is in the window when its last message is, so these run slightly high. Hover the number for all-time."
          ></app-info-hint>
        </th>
        <th class="num">Lobby</th>
        <th class="num sortable" [class.sorted]="sortKey === 'eventsJoined90'" (click)="sortBy('eventsJoined90')">
          Events<app-info-hint label="Events" text="Events dated in the last 90 days that they are a member of / all time. By event date, not join date: memberships imported at the Supabase cutover all share one join day. Click the number to see which spaces, and to open one."></app-info-hint>
        </th>
        <th class="num">Posts</th>
        <th class="num">Likes</th>
        <th class="num">Favs<app-info-hint label="Favorites"
          text="Members they favorited / members who favorited them."
        ></app-info-hint></th>
        <th class="num">Views<app-info-hint label="Profile views"
          text="Times their profile was opened by someone else in the last 90 days."
        ></app-info-hint></th>
        <th class="sortable" [class.sorted]="sortKey === 'contactedAt'" (click)="sortBy('contactedAt')">
          Outreach<app-info-hint label="Outreach"
            text="When the NX2U Team account last messaged this member from the admin, and whether they have written back in that chat. A dash means nobody has approached them yet."
          ></app-info-hint>
        </th>
        <th class="sortable" [class.sorted]="sortKey === 'lastSeen'" (click)="sortBy('lastSeen')">Last seen</th>
        <th>Joined</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of rows" [attr.data-tier]="r.tier"
          [class.internal]="r.isInternal" [class.banned]="r.isBanned">
        <td>
          <div class="title">
            <app-person-link [uid]="r.uid" [name]="r.name || r.uid" (failed)="error = $event"></app-person-link>
            <span class="flag" *ngIf="r.isInternal" title="Internal account">internal</span>
            <span class="flag bad" *ngIf="r.isBanned" title="Blocked">blocked</span>
            <span class="flag warn" *ngIf="r.isFlagged && !r.isBanned" title="Spam-flagged">flagged</span>
            <span class="flag" *ngIf="!r.isListed" title="Profile too thin to be shown to others">unlisted</span>
          </div>
          <div class="meta">{{ byline(r) || '—' }}</div>
        </td>
        <td><span class="pill" [attr.data-tier]="r.tier">{{ tierLabel(r.tier) }}</span></td>
        <td class="num score">{{ r.score }}</td>
        <td class="num">{{ r.activeDays30 }} <span class="meta">/ {{ r.activeDays90 }}</span></td>
        <td class="num" [title]="'All time: ' + r.chatMessages + ' messages, ' + r.conversationsStarted + ' started, ' + r.conversationsReplied + ' answered'">
          {{ r.chatMessages90 }}
          <span class="meta">· {{ r.conversationsStarted90 }} / {{ r.conversationsReplied90 }}</span>
        </td>
        <td class="num">{{ r.lobbyMessages90 || '' }}</td>
        <td class="num">
          <button
            *ngIf="r.events.length; else noEvents"
            type="button"
            class="events-trigger"
            [matMenuTriggerFor]="eventsMenu"
            [matMenuTriggerData]="eventMenuData(r)"
            [title]="'Which spaces ' + (r.name || 'this member') + ' is in'"
          >
            {{ r.eventsJoined90 }} <span class="meta">/ {{ r.eventsJoined }}</span>
          </button>
          <ng-template #noEvents>0 <span class="meta">/ 0</span></ng-template>
        </td>
        <td class="num">{{ r.posts90 || '' }}</td>
        <td class="num">{{ r.likes90 || '' }}</td>
        <td class="num">{{ r.favoritesGiven }} <span class="meta">/ {{ r.favoritedBy }}</span></td>
        <td class="num">{{ r.profileViews90 || '' }}</td>
        <td class="meta outreach-cell" [title]="r.contactPreview || ''">
          <ng-container *ngIf="r.contactedAt; else notContacted">
            {{ r.contactedAt | date: 'd MMM' }}
            <span class="flag good" *ngIf="r.repliedToTeam">replied</span>
            <span class="flag" *ngIf="!r.repliedToTeam">no reply</span>
          </ng-container>
          <ng-template #notContacted>—</ng-template>
        </td>
        <td class="meta">{{ r.lastSeen | date: 'd MMM yy' }}</td>
        <td class="meta">{{ r.createdAt | date: 'MMM yy' }}</td>
      </tr>
    </tbody>
  </table>

  <p class="empty" *ngIf="!loading && !rows.length && board?.computedAt">
    No members match this filter.
  </p>

  <!-- One menu for the whole board; each row hands over its own spaces when it
       opens it. See eventMenuData for why it is not one menu per row. -->
  <mat-menu #eventsMenu="matMenu" class="events-menu">
    <ng-template matMenuContent let-events="events" let-name="name">
      <div class="events-pop">
        <div class="pop-head">
          {{ name }} &middot; {{ events.length }} {{ events.length === 1 ? 'space' : 'spaces' }}
        </div>
        <!-- app-event-link, the same way into a space every other board uses,
             rather than a routerLink written again here. It carries its own
             anchor, so these rows are plain rows and not mat-menu-items. -->
        <div class="events-list">
          <div class="pop-row" *ngFor="let e of events">
            <app-event-link [eventId]="e.id" [title]="e.title"></app-event-link>
            <span class="meta">{{ e.startDate ? (e.startDate | date: 'MMM yy') : 'no date' }}</span>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-menu>
</div>
